import { useMutation } from 'react-query'
import { showConfirmAlert, showError } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { deleteUnidade } from '../../core/_requests'
import { TableBulkDangerButton, TableSelectionBar, useToast } from '../../../../../../components'

export const UnidadesListGrouping = () => {
  const { selected, clearSelected } = useListView()
  const { refetch } = useQueryResponse()
  const { showToast } = useToast()
  const count = selected.length

  // Remove uma a uma, como antes (o backend não tem exclusão em lote).
  const deleteSelected = useMutation(
    async () => {
      for (const id of selected) await deleteUnidade(Number(id))
    },
    {
      onSuccess: () => {
        showToast({
          variant: 'success',
          title: count === 1 ? '1 unidade removida.' : `${count} unidades removidas.`,
        })
        clearSelected()
        refetch()
      },
      onError: (error) => {
        showError(error)
        refetch()
      },
    }
  )

  const askRemove = async () => {
    const confirmed = await showConfirmAlert({
      title: count === 1 ? 'Remover 1 unidade?' : `Remover ${count} unidades?`,
      text: 'As unidades/setores selecionados e seus endereços serão excluídos. Essa ação não pode ser desfeita.',
      confirmButtonText: count === 1 ? 'Remover unidade' : `Remover ${count} unidades`,
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (confirmed) await deleteSelected.mutateAsync()
  }

  return (
    <TableSelectionBar count={count} onClear={clearSelected}>
      <TableBulkDangerButton onClick={askRemove} disabled={deleteSelected.isLoading}>
        {count === 1 ? 'Remover selecionada' : 'Remover selecionadas'}
      </TableBulkDangerButton>
    </TableSelectionBar>
  )
}
